const P_ORDER = ["Sun","Moon","Mars","Mercury","Jupiter","Venus","Saturn","Rahu","Ketu"];
const SIGNS = ["Ari","Tau","Gem","Can","Leo","Vir","Lib","Sco","Sag","Cap","Aqu","Pis"];

function bar(v, max=100, color="#D4AF37") {
  return (
    <div className="h-1.5 bg-[#0F1115] rounded-sm overflow-hidden">
      <div className="h-full transition-all duration-500" style={{ width: `${Math.min(100, (v/max)*100)}%`, backgroundColor: color }} />
    </div>
  );
}

const stateColor = (s) => s === "Strong" ? "#7B906F" : s === "Weak" ? "#C15C3D" : "#A8896C";

export default function StrengthsView({ strengths }) {
  if (!strengths) return null;
  const { shadbala, bav, sav, avastha, holistic, ishta_kashta } = strengths;
  return (
    <div className="space-y-8">
      <div>
        <h3 className="font-heading text-2xl text-[#E6E1D6] mb-4">Holistic Planetary Score</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
          {P_ORDER.map(p => (
            <div key={p} className="border border-[#2A2D35] p-4 bg-[#181A1F]" data-testid={`holistic-${p}`}>
              <div className="flex items-baseline justify-between">
                <div className="font-heading text-lg text-[#E6E1D6]">{p}</div>
                <div className="text-xs uppercase tracking-widest font-mono" style={{color: stateColor(holistic[p].state)}}>
                  {holistic[p].state}
                </div>
              </div>
              <div className="mt-2 font-mono text-3xl text-[#D4AF37]">{holistic[p].score}<span className="text-sm text-[#6E6B64]">/100</span></div>
              <div className="mt-3 space-y-2 text-xs font-mono text-[#A19E95]">
                <div>Rupa {holistic[p].rupa_score} · BAV {holistic[p].bav_score} · Dignity {holistic[p].dignity_score}</div>
                <div className="text-[#6E6B64]">Avastha: {avastha[p].deeptadi} · {avastha[p].baladi} · {avastha[p].jagrat}</div>
              </div>
              {bar(holistic[p].score, 100, stateColor(holistic[p].state))}
            </div>
          ))}
        </div>
      </div>

      <div>
        <h3 className="font-heading text-2xl text-[#E6E1D6] mb-4">Shadbala (Virupas)</h3>
        <div className="border border-[#2A2D35] overflow-x-auto">
          <table className="w-full font-mono text-xs">
            <thead className="bg-[#0F1115] text-[#6E6B64]">
              <tr>
                {["Planet","Sthana","Dig","Kaala","Cheshta","Naisargika","Drik","Total","Rupa","Ishta","Kashta"].map(h => (
                  <th key={h} className="px-3 py-2 text-left">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody className="text-[#E6E1D6]">
              {P_ORDER.map(p => (
                <tr key={p} className="border-t border-[#2A2D35]" data-testid={`shad-${p}`}>
                  <td className="px-3 py-2 text-[#D4AF37]">{p}</td>
                  <td className="px-3">{shadbala[p].sthana}</td>
                  <td className="px-3">{shadbala[p].dig}</td>
                  <td className="px-3">{shadbala[p].kaala}</td>
                  <td className="px-3">{shadbala[p].cheshta}</td>
                  <td className="px-3">{shadbala[p].naisargika}</td>
                  <td className="px-3">{shadbala[p].drik}</td>
                  <td className="px-3 text-[#E6E1D6]">{shadbala[p].total}</td>
                  <td className="px-3 text-[#D4AF37]">{shadbala[p].rupa}</td>
                  <td className="px-3">{ishta_kashta[p]?.ishta}</td>
                  <td className="px-3">{ishta_kashta[p]?.kashta}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div>
        <h3 className="font-heading text-2xl text-[#E6E1D6] mb-4">Ashtakavarga — SAV (Sarva)</h3>
        <div className="grid grid-cols-12 gap-1">
          {sav.map((v, i) => (
            <div key={SIGNS[i]} className="border border-[#2A2D35] py-3 text-center bg-[#181A1F]" data-testid={`sav-${i}`}>
              <div className="font-mono text-[10px] text-[#6E6B64]">{SIGNS[i]}</div>
              <div className="font-mono text-2xl mt-1" style={{color: v >= 30 ? "#7B906F" : v <= 24 ? "#C15C3D" : "#E6E1D6"}}>{v}</div>
            </div>
          ))}
        </div>
        <div className="text-xs text-[#6E6B64] font-mono mt-2">≥30 auspicious · ≤24 weak · Average 28</div>
      </div>
    </div>
  );
}
